import React from 'react'
import "./Get_in_touch.css"
import { Form, InputGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function Get_in_touch() {
    return (
        <>
            <section className='Get_in_touch'>
                <div className="container">
                    <div className='content_holder'>
                        <h4>Grow Your FMCG Business with a Trusted Global Partner!</h4>
                        <p>Let’s connect and supply you with premium food, beverages, and spirits across Africa.</p>

                        <InputGroup className="mb-3">
                            <Form.Control
                                placeholder="Recipient's username"
                                aria-label="Recipient's username"
                                aria-describedby="basic-addon2"
                            />
                            <Link to={"/contact"}>
                                <InputGroup.Text id="basic-addon2">Get In Touch</InputGroup.Text>
                            </Link>
                        </InputGroup>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Get_in_touch